"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The CreateBatchUploadResult model module.
 * @module model/CreateBatchUploadResult
 * @version 1.1.3-alpha.1
 */
class CreateBatchUploadResult {
  /**
   * Constructs a new <code>CreateBatchUploadResult</code>.
   * @alias module:model/CreateBatchUploadResult
   */
  constructor() {
    CreateBatchUploadResult.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>CreateBatchUploadResult</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CreateBatchUploadResult} obj Optional instance to populate.
   * @return {module:model/CreateBatchUploadResult} The populated <code>CreateBatchUploadResult</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CreateBatchUploadResult();
      if (data.hasOwnProperty('batch_id')) {
        obj['batch_id'] = _ApiClient.default.convertToType(data['batch_id'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>CreateBatchUploadResult</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CreateBatchUploadResult</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['batch_id'] && !(typeof data['batch_id'] === 'string' || data['batch_id'] instanceof String)) {
      throw new Error("Expected the field `batch_id` to be a primitive type in the JSON string but got " + data['batch_id']);
    }
    return true;
  }
}

/**
 * @member {String} batch_id
 */
CreateBatchUploadResult.prototype['batch_id'] = undefined;
var _default = CreateBatchUploadResult;
exports.default = _default;